import moment from 'moment-timezone';
import { freezeBody, unfreezeBody } from './freezeScroll';
import { createCookie, readCookie, eraseCookie } from './cookies';

/* NOTICE OVERLAY */

// get overlay & body
const body = document.querySelector('body');
const noticeOverlay = document.getElementById('notice-overlay');
const noticeOverlayClose = document.querySelector('.notice-overlay__close');

// open and closes the overlay
const openNoticeOverlay = ()=> {
    body.classList.add('open-notice-overlay');
    freezeBody();
}
const closeNoticeOverlay = ()=> {
    body.classList.remove('open-notice-overlay');
    unfreezeBody();
}

// set close events and overlay launch
if( body && noticeOverlay && noticeOverlayClose  ){

    const isScheduled = noticeOverlay.dataset.scheduled;
    let displayOverlay = false;

    if(isScheduled == 'true'){
        // scheduled, so display if today is within range
        // console.log(`isScheduled(${typeof isScheduled}): ${isScheduled}, check dates:`);
        displayOverlay = isTodayWithinDateRange(noticeOverlay);
    } else {
        // not scheduled, so display
        displayOverlay = true;
    }

    if(displayOverlay){
        // check for cookie
        var noticeOverlayCookie = readCookie('noticeOverlay');
        // if theres no cookie
        if (!noticeOverlayCookie) {
            // set up close button close
            noticeOverlayClose.addEventListener('click', (event) => {
                event.preventDefault();
                closeNoticeOverlay();
            });
            // set cookie, expires in one day
            createCookie('noticeOverlay', 'set', 1);
            // show overlay after a brief delay
            setTimeout(function(){
                openNoticeOverlay();
            },2000);
        }
    }
}


function isTodayWithinDateRange(element,timeZone = 'America/New_York'){

    // get user timezone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // get current time
    const currentDateTime = moment.tz(userTimeZone);
    // get start and end date, in eastern time
    const startDate = moment.tz(element.dataset.start, 'MM/DD/YYYY h:mm a', timeZone);
    const endDate = moment.tz(element.dataset.end, 'MM/DD/YYYY h:mm a', timeZone);
    // troubleshoot
    console.log(`currentDateTime: ${currentDateTime.format("dddd, MMMM Do YYYY, h:mm:ss a z")}\nstartDate: ${startDate.format("dddd, MMMM Do YYYY, h:mm:ss a z")}\nendDate: ${endDate.format("dddd, MMMM Do YYYY, h:mm:ss a z")}\nMinutes ${ startDate.diff(currentDateTime, 'minutes') < 0 ? `after` : `until` } start:${Math. abs(startDate.diff(currentDateTime, 'minutes'))}\nHours ${ endDate.diff(currentDateTime, 'minutes') < 0 ? `after` : `until` } end time ${endDate.diff(currentDateTime, 'hours')}\nWithin range:${currentDateTime.isBetween(startDate,endDate)}\nscheduleTimeZone: ${timeZone}\nuserTimeZone: ${userTimeZone}`);

    return currentDateTime.isBetween(startDate,endDate);
}

export {
    isTodayWithinDateRange
}